module.exports = __webpack_public_path__ + "fonts/bold.6659480.woff2";